export default __webpack_public_path__ + "static/media/saved.44fe3cbc.svg";